import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface DosyaBorcluIsyeriSgkTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
}

export interface DosyaBorcluIsyeriSgkCevap extends ISorguSonuc<IDosyaBorcluIsyeriSgkSonuc> {}

// DEV-3354: UYAP "Adalet" zarfına geçti (bkz. icrapro-laravel-api DEV-2248): gövde artık
// isYeriBilgi.data altında ve TE_*/TY_* alan adları küçük harfe indi.
export interface IDosyaBorcluIsyeriSgkSonuc {
    isYeriBilgi: IAdaletZarf,
    yoneticiBilgileri?: IAdaletZarf
}

export interface IAdaletZarf {
    data: IIsYeriBilgiData,
    metadata?: IAdaletMetadata
}

export interface IAdaletMetadata {
    FMTY: string,
    FMTE: string,
    FMC: string
}

export interface IIsYeriBilgiData {
    hataKodu: number,               // 0: başarılı 995: kayıt bulunamadı
    hataMesaji?: string,
    isyerleri?: Array<IIsyeri>
}

export interface IIsyeri {
    teadres1: string,
    teadres2: string,
    teadres3: string,
    teadres4: string,
    techeckdigit: string,
    tediskapi: string,
    teeskisubekod: string,
    teickapi: string,
    teilcekod: string,
    teilkod: string,
    teiskolukod: string,
    teisyeriunvan: string,
    tekankapaltar: string | null,
    temahiyet: string,
    temahiyetkod: string,
    tesirano: string,
    testatusstring: string,
    tetesciltip: string,
    teunvan1: string,
    teunvan2: string,
    teunvan3: string | null,
    teyenisubekod: string,
    yoneticiler: Array<IYonetici>
}

export interface IYonetici {
    tyad: string,
    tyanaad: string,
    tybabaad: string,
    tycinsiyet: string,
    tycinsiyetaciklama: string,
    tydogumtarih: string,
    tydogumyer: string,
    tyeskisubekod: string,
    tyilkod: string,
    tymernisno: string,
    tysirano: string,
    tysoyad: string,
    tyunvan: string | null,
    tyuyruk: string,
    tyyenisubekod: string,
    tyykod: string,
    tyykodaciklama: string
}

export default class DosyaBorcluIsyeriSgk extends UyapRequest<DosyaBorcluIsyeriSgkTalep, DosyaBorcluIsyeriSgkCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu işyeri SGK bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "DosyaBorcluIsyeriSgk_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IuXpdpAdThuchFVBCQ+3yaRwsqDA8Aqxs@85O9Q51fsg","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 13:02","sorguSonucDVO":{"yoneticiBilgileri":{"data":{"hataKodu":0,"isNew":true},"metadata":{"FMTY":"SUCCESS","FMTE":"İşlem başarıyla gerçekleştirildi!","FMC":"ADALET_SUCCESS"},"isNew":true},"isYeriBilgi":{"data":{"hataKodu":0,"isyerleri":[{"teadres1":"DEMETEVLER 4.CAD","teadres2":"NO.77/C","teadres3":"ANKARA","teadres4":"YENİMAHALLE","techeckdigit":"30","tediskapi":"1","teeskisubekod":"01","teickapi":"0","teilcekod":"21","teilkod":"06","teiskolukod":"1629","teisyeriunvan":"AHMETİ MÜNÜR YALÇINALP","tekankapaltar":"2005-01-19","temahiyet":"TABLO ALIM SATIM VE ÇERÇEVE İM","temahiyetkod":"2","tesirano":"1109933","testatusstring":"000000000000000","tetesciltip":"1","teunvan1":"AHMETİ MÜN","teunvan2":"ÜR YALÇINALP","teunvan3":null,"teyenisubekod":"01","yoneticiler":[{"tyad":"AHMETİ MÜNÜR","tyanaad":"ŞADİYE","tybabaad":"ABDULKADİR","tycinsiyet":"E","tycinsiyetaciklama":"ERKEK","tydogumtarih":"25.08.1957","tydogumyer":"SİVAS","tyeskisubekod":"01","tyilkod":"006","tymernisno":"47161224210","tysirano":"1109933","tysoyad":"YALÇINALP","tyunvan":null,"tyuyruk":"TC","tyyenisubekod":"01","tyykod":"I","tyykodaciklama":"İŞVEREN","isNew":true}],"isNew":true}],"isNew":true},"metadata":{"FMTY":"SUCCESS","FMTE":"İşlem başarıyla gerçekleştirildi!","FMC":"ADALET_SUCCESS"},"isNew":true}},"sorgulamaTuru":"SSK İş Yeri Bilgisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false}
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_isYeriBilgileri.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluIsyeriSgkCevap> {
        // DEV-3354: kimlik bilgisi eksikse sorguSonucDVO düz hata metni, kayıt yoksa hiç dönmüyor.
        const sonuc = data.sorguSonucDVO;
        if (typeof sonuc === "string" && sonuc) {
            data.message = sonuc;
            return data;
        }
        const bilgi = sonuc?.isYeriBilgi?.data;
        if (data.sorguSonucu && bilgi?.hataKodu == 0)
            data.message = "İşyeri bilgisi bulundu";
        else
            data.message = bilgi?.hataMesaji || "İşyeri bilgisi bulunamadı";
        return data;
    }

}

